export const getAdIds = (): Promise<{ adid: string; gaid: string; idfa: string; }> => new Promise((resolve) => {
  try {
    const SLADJust = Mach.requireModule('SLADJust');
    const SLCommon = Mach.requireModule('SLCommon');

    const adid = SLADJust.adid(); // adjust id
    let gaid = ''; // google 广告标识
    const idfa = ''; // 苹果广告标识
    if (Mach.env.isIOS) {
      resolve({
        adid,
        gaid,
        idfa: SLCommon.idfa() || '',
      });
    } else {
      SLCommon.gaid((result) => {
        gaid = result?.gaid || '';
        resolve({
          adid,
          gaid,
          idfa,
        });
      });
    }
  } catch (error) {
    console.log('getAdIds error:', error);
    resolve({
      adid: '',
      gaid: '',
      idfa: '',
    });
  }
});
